import _en from './translations/en.json.mjs';
import React__default from 'react';
import { Tooltip } from '@shopify/polaris';
import { useI18n } from '@shopify/react-i18n';
import { SizeValue } from '../../types.mjs';
import expand from './icons/expand.svg.mjs';
import fullscreen from './icons/fullscreen.svg.mjs';
import minimize from './icons/minimize.svg.mjs';
import { PreventBlur } from '../../../PreventBlur/PreventBlur.mjs';
import { PlainAction } from '../../../../../PlainAction/PlainAction.mjs';

function SizeSwitcher({
  size,
  onChange
}) {
  const [i18n] = useI18n({
    id: 'SizeSwitcher_168ievs',
    fallback: _en,
    translations(locale) {
      if (["cs", "da", "de", "es", "fi", "fr", "it", "ja", "ko", "nb", "nl", "pl", "pt-BR", "pt-PT", "sv", "th", "tr", "vi", "zh-CN", "zh-TW"].indexOf(locale) < 0) {
        return;
      }
      return import( /* webpackChunkName: "SizeSwitcher_168ievs-i18n", webpackMode: "lazy-once" */`./translations/${locale}.json`).then(dict => dict && dict.default);
    }
  });
  const sizeData = {
    [SizeValue.Default]: {
      content: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Default}.content`),
      icon: expand,
      accessibilityLabel: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Default}.accessibilityLabel`)
    },
    [SizeValue.Expanded]: {
      content: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Expanded}.content`),
      icon: fullscreen,
      accessibilityLabel: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Expanded}.accessibilityLabel`)
    },
    [SizeValue.Fullscreen]: {
      content: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Fullscreen}.content`),
      icon: minimize,
      accessibilityLabel: i18n.translate(`RichText.ResizeableCombo.SizeSwitcher.${SizeValue.Fullscreen}.accessibilityLabel`)
    }
  };
  const currentSizeData = sizeData[size];
  return /*#__PURE__*/React__default.createElement(Tooltip, {
    preferredPosition: "above",
    content: currentSizeData.content,
    dismissOnMouseOut: true
  }, /*#__PURE__*/React__default.createElement(PreventBlur, null, /*#__PURE__*/React__default.createElement(PlainAction, {
    icon: currentSizeData.icon,
    accessibilityLabel: currentSizeData.accessibilityLabel,
    onAction: onChange
  })));
}

export { SizeSwitcher };
